module.exports = __webpack_public_path__ + "img/@service_img_01.dcbe0e27.jpg";